import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';

/**
 * Al posto del profilo per gli ospiti, come in phpBB (ucp.php?mode=login dal profilo): il messaggio, il login e,
 * se le registrazioni sono aperte, il riquadro Register.
 */
export default class LoginRequired extends Component {
  view() {
    return m("div", {
      className: "container LoginRequired"
    }, m("div", {
      className: "Panel"
    }, m("h2", null, "The board requires you to be registered and logged in to view profiles."), m(Button, {
      className: "Button PhpbbButton PhpbbButton--primary",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, "Login")), app.forum.attribute('allowSignUp') && m("div", {
      className: "Panel"
    }, m("h3", null, "Register"), m("p", null, "In order to login you must be registered. Registering takes only a few moments but gives you increased capabilities. The board administrator may also grant additional permissions to registered users."), m(Button, {
      className: "Button PhpbbButton PhpbbButton--primary",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
    }, "Register")));
  }
}
flarum.reg.add('runeaudio-theme', 'forum/components/LoginRequired', LoginRequired);